import { useContext } from 'react';
import SiteContext from '../context/SiteSettingsProvider';

const useSiteSettings = () => useContext(SiteContext);

export default useSiteSettings;
